<template>
  <Tariff type="exam"></Tariff>
</template>

<script>
import Tariff from '@/components/tariff'
export default {
  components: {
    Tariff,
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/tariff/index.vue